<template>
    <div class="net-monitor" :style="netMonitorFixed == true ? 'dispaly:fixed' :'display:none'">
        <!--<Poptip placement="right" width="250" trigger="click" >
            <div class="icon-phone"><Icon type="ios-call"/></div>
            <template #content >
                <div class="pop-box-cont">
                    咨询热线
                    <h3>021-38586999</h3>
                    <a @click="close">close</a>
                </div>
            </template>
        </Poptip>-->
        <Poptip v-model="visible" trigger="click" placement="left" :transfer="false">
<!--            <a>Click</a>-->
            <div class="icon-phone"><Icon type="ios-call"/></div>
            <template #content>
                <div class=" pop-box-cont1 ">
                    <div class="ballon">招商热线</div>
                    <h3 style="font-size:20px;text-align: center">021-38586888</h3>
                </div>
                <a @click="close" style="text-align: center;display: inline-block;width:100%;"><Icon size="30" type="md-close-circle" /></a>
            </template>
        </Poptip>
       <!-- <div class="ivu-poptip" trigger="click" >
            <div class="ivu-poptip-rel" >
                <div class="icon-phone"><Icon type="ios-call"/></div>
                <template class="ivu-poptip-popper ivu-poptip-transfer v-transfer-dom " style="width: 200px;
                    z-index: 1066;
                    position: absolute;
                    will-change: top, left;
                    top: 1451px;
                    left: 999px;
                    display: block;">
                    <div class="ivu-pop-content tel-pop">
                    <div class="ivu-poptip-arrow" style="right:53px;top:50%;margin-top:-7px;border-width:7px 0 7px 7px;border-left-color:rgb(255,255,255)"></div>
                    <div class="ivu-pop-inner">
                        <div class="ivu-pop-body">
                            <div class="pop-box-cont pop-box-cont1 ">
                            <div class="ballon">招商热线</div>
                            <h3 style="font-size:24px">021-38586999</h3>
                                <a @click="close">close</a>
                            </div>
                        </div>
                    </div>

                    </div>
                </template>
            </div>

        </div>-->

        <Poptip  placement="right" width="200" trigger="hover">
            <div class="icon-ecode">
                <Icon type="md-qr-scanner"/>
            </div>
            <template #content>
                <div class="pop-box-cont">
                    <Row>
                        <Col span="10" offset="1">
                            服务号
                            <div class="ecode-img">
                                <img src="../assets/images/web/ico-fuwu.jpg"/>
                            </div>
                        </Col>
                        <Col span="10" offset="2">
                            订阅号
                            <div class="ecode-img">
                                <img src="../assets/images/web/ico-dingyue.jpg"/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </template>
        </Poptip>

    </div>
</template>

<script>
    export default {
        name: "NetMonitor",
        data(){
            return{
                transfer: true,
                netMonitorFixed:true,
                visible: true,
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            close () {
                this.visible = false;
            },
            handleScroll () {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                // console.log(scrollTop)
                // var offsetTop = document.querySelector('#navBar').offsetTop
                var vm=this
                if (scrollTop >= 0) {
                    // vm.netMonitorFixed = true
                } else {
                    // vm.netMonitorFixed = false
                }
            },
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll,this.close)

        },
    }
</script>

<style lang="less">
    .net-monitor{
        position: fixed !important;
        flex-flow: column;
        right: 10px;
        bottom:30px;
        z-index:1000;
        .ivu-poptip{
            display: block;
            margin-bottom: 10px;
            text-align: center;
            color:#000000;
            [class^="icon-"]{
                font-size:24px;
                background-color: rgba(255,255,255,0.5);
                color:#300;
                width:44px;
                height:44px;
                text-align: center;
                line-height: 44px;
                border-radius:22px;
                box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);

            }
        }
        .ivu-poptip:hover{
            [class^="icon-"]:hover{
                color:#0C76C7;
            }
        }
    }
    .pop-hotLine{
        position: fixed !important;
    }
    .pop-box-cont1{
        color:#000000;
        width: 200px;
        max-height: 200px;
        overflow:hidden;
        margin: 5px 0;
        padding: 5px 0;
        background-color: #fff;
        box-sizing: border-box;
        border-radius: 4px;
        /*box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);*/
        /*position: absolute;*/
        z-index: 800;
        /*right:60px;*/
        /*bottom:0;*/
        .ivu-poptip-arrow{
            box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
        }
        .ivu-poptip-arrow::after{
            content: " ";
            border-right-width: 0;
            border-left-width: 7px;
            border-left-color: #fff;
            bottom: -7px;
            box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
        }
    }
    .pop-box-cont{
        color:#000000;
        h3{
            font-size:28px;
        }
        .ivu-row{
            .ivu-col{
                text-align: center;
                img{
                    width: 100%;
                }
            }
        }
    }

    @keyframes scaleDraw {



        /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
        0% {
            transform: scale(1);/*开始为原始大小*/
        }
        25% {
            transform: scale(1.5);/*放大1.1倍*/
        }
        50% {
            transform: scale(1);
        }
        75% {
            transform: scale(1.5);
        }
    }

    .ballon {
        text-align: center;
        /*width: 150px;*/

        /*height: 200px;*/

        /*margin: 100px auto;*/

        -webkit-animation-name: scaleDraw;/*关键帧名称*/

        -webkit-animation-timing-function: ease-in-out;/*动画的速度曲线*/

        -webkit-animation-iteration-count: infinite;/*动画播放的次数*/

        -webkit-animation-duration: 5s;/*动画所花费的时间*/



        /*可以简写为*/

        /* animation: scaleDraw 5s ease-in-out infinite; */

        /* -webkit-animation: scaleDraw 5s ease-in-out infinite; */

    }
</style>